import PropTypes from 'prop-types';
import React from 'react';
import TimelineContainer from 'common/timeline/containers/timeline-container';
import { useParams } from 'react-router';

const CustomerTimeline = ({ renderMenu, ...rest }) => {
  const params = useParams();

  return <>
    <TimelineContainer
      id={rest?.id}
      type='customer'
      jumpToDate={
        params.filtervalue ? null : params.jumpToDateOrFilter
      }
      activeFilter={
        params.filtervalue && params.jumpToDateOrFilter
      }
      activeFilterValue={params.filtervalue}
      canCreateTicket={true}
      canCreateOrder={false}
      renderMenu={renderMenu}
      {...rest}
    />
  </>;
};
CustomerTimeline.propTypes = {
  id: PropTypes.string,
  filter: PropTypes.string,
  renderMenu: PropTypes.func.isRequired,
};

export default CustomerTimeline;
